// extracted by mini-css-extract-plugin
module.exports = {"title":"PageTitle_title__BvDM8","sub":"PageTitle_sub__Biysp"};